// Auto generated file, do not manually modify!
// com.hotpads.rentcreditreport.client.enums.reportingforallenrollment.EnrollmentProvider

export enum EnrollmentProvider {
  ESUSU = 'ESUSU',
}

export const EnrollmentProvider_values = [EnrollmentProvider.ESUSU] as const;
